export function validUuid(uuid) {
    let regex = /^[a-z,0-9,-]{36,36}$/;
    return regex.test(uuid);
}